import { CLOSE_TOAST, OPEN_TOAST } from "@stofloos/actions/toast";

const toast = (state = {}, action) => {
	switch (action.type) {
		case OPEN_TOAST:
			return {
				...state,
				status: action.status,
				message: action.message,
				swToastOpen: true
			};
		case CLOSE_TOAST:
			return {
				...state,
				swToastOpen: false
			};
		default:
			return state;
	}
};

export default toast;
